import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'dip-switch',
  templateUrl: './dip-switch.component.html',
  styleUrl: `./dip-switch.component.scss`,
  
})
export class DipSwitchComponent {
  public value = input.required<number>();
  public valueChanged = output<number>();

  public readOnly = input<boolean>(false);
  public bits = input<number>(6);

  public bitsArray = computed(() => {
    let arr = [];
    let v = this.value();
    for (let i = 0; i < this.bits(); i++) {
      arr.push((v >> i) & 1);
    }
    return arr;
  });

  public onValueChanged(v: number) {
    this.valueChanged.emit(v);
  }

  public onSwitchChanged(v: boolean, index: number) {
    let bit = v ? 0 : 1;
    this.onValueChanged((this.value() & ~(1 << index)) | (bit << index));
  }
}
